<template>
  <div  class="OrderManageList-root">
    <div v-if="authority" class="search-pane">
       <div class="search_content">
         <pro-search 
      :fileds="ExtendedSearchFiled"
      :form="queryForm"
      @search="handleSearch"
      @reset="handleReset"
      >
        <template slot="warehouseCode">
          <!-- <cascaderSelect v-if="isEnterprise" ref="cascaderSelect" :is-default-select="false" @change="handleWhChange"></cascaderSelect> -->
          <select-dom  ref="selectDom" v-model="queryForm.shipperId" :is-every-request="false" :list="ProjectList" @onSearch="onSearchProject" @checkedList="checkedList" />
        </template>
        <template slot="batchAttrName">
           <a-input-group compact>
                <a-select
                  v-model="queryForm.batchAttrName"
                  style="width: 120px;"
                  :get-popup-container="triggerNode => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in BATCHLIST"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{item.label}}
                  </a-select-option>
                </a-select>
                <a-input
                  v-model="queryForm.batchAttrValue"
                  placeholder="请输入"
                  style="width: calc(100% - 120px);"
                  @pressEnter="getData"
                />
              </a-input-group>
        </template>
      </pro-search>
       </div>
      <div v-if="authority" class="table-content">
      <a-table
        :columns="ExtendedTableColumns"
        :data-source="goodsData"
        class="table-sigle"
        row-key="id"
        :loading="loading"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="goodsName" slot-scope="text">
          <a-tooltip>
            <template slot="title">{{text}}</template>
            <p class="overlength">{{text}}</p>
            </a-tooltip>
        </template>
      </a-table>
    </div>
    <div v-else class="noAuthority">
      暂未对个人货主开放，敬请期待
    </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import SelectDom from '@/components/select/SelectDom'
// import cascaderSelect from '@/components/cascaderSelect/index.vue'
import ProSearch from '@/components/TableSearch/index.vue'
import currency from 'currency.js'
import { ExtendedTableColumns,ExtendedSearchFiled } from '../constant.js'
import { getWareHouse } from '../../../../warehouseOrder/api'
import { overdueStock } from '../../api'

const BATCHLIST = [
  {
    value: 'box_no',
    label: '柜号',
  },
  {
    value: 'customer_batch',
    label: '客户批次',
  },
  {
    value: 'expire_date',
    label: '到期日期',
  },
  {
    value: 'inspectionQuearantineCode',
    label: '检验检疫文',
  },
  {
    value: 'productDate',
    label: '生产日期',
  },
  {
    value: 'store_date',
    label: '入库日期',
  },
  {
    value: 'store_no',
    label: '入库单号',
  },
  {
    value: 'traceCode',
    label: '追溯码',
  },
]

export default {
  name: 'Extended',
  components: {
    SelectDom,
    // cascaderSelect,
    ProSearch
  },
   props:{
      checkTab:{
        type:String,
        default:'extended'
      }
    },
  data () {
    return {
      ExtendedTableColumns,
      ExtendedSearchFiled,
      authority: true,
      openMore: false,
      goodsData: [],
      isEnterprise:false,
      loading:false,
      pageSize: 10,
      pagination: {
          current: 1,
          total: 0,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.pageSize = pageSize
          },
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条`
      },
      ProjectList: [],
      queryForm: {
      },
      BATCHLIST,
    }
  },
  computed: {
  },
  watch:{
      checkTab(){
        if(this.checkTab==='extended'){
         this.getData();
        }
      }
    },
  created() {
    // const {creditCode}=this.$store.state.user
    //   if(!creditCode){
    //     this.getWareHouse()
    //   }else{
    //     this.getData();
    //   }
    //   this.isEnterprise=!!creditCode
  },
  methods: {
    init(){
       this.getWareHouse()
    },
     handleSearch(form){
      this.pagination.current=1
      this.queryForm={
        ...form,
      }
      this.getData();
    },
    handleWhChange(data){
      this.ProjectList=[data]
       if(data){
        this.queryForm.warehouse_name = data.label
        this.getData(true)
        }else{
          this.queryForm.warehouse_name = ''
          this.getData(true)
        }
    },
    checkedList(data){
      this.queryForm.warehouse_name = data.label;
      this.queryForm.warehouseCode = data.tenantId
      this.getData(true)
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.getData();
    },
   async getData(current = null){
      this.loading=true;
      if(current){
        this.pagination.current = 1
      }
      const params = {
        size: this.pageSize,
        page: this.pagination.current,
        sort: [
        {
            "odue_amount_total": {
                "order": "desc"
            }
        }
      ]
      }
    const {shipperId,...restParams} = this.queryForm;
    if(!shipperId){
      this.$message.warning('未选择仓库,无法查询数据')
      this.loading=false;
      return
    }
     const {creditCode,customers,customerId}=this.$store.state.user;
      let customerIds=[];
      if(creditCode){
        customerIds=customers.map(item=>item.customerId)
      }else{
        customerIds=[customerId]
      }
    try {
      const res= await overdueStock({...params,filter:{...restParams,shipperId,shipper_id:customerIds}} )
      this.goodsData = res.records
      this.pagination.total = res.total
      this.countTotal(this.goodsData,res.total)
      this.loading=false;
    } catch (error) {
      this.loading=false;
      this.countTotal([],0)
    }
    },
    countTotal(data,total){
      const messageData ={
        total,
        defaultTotal:0,
        bigTotal:0,
      }
      data.forEach(item=>{
        messageData.defaultTotal= currency( messageData.defaultTotal).add(item.odue_amount_total||0)
        messageData.bigTotal= currency( messageData.bigTotal).add(item.odue_big_amount_total||0)
      })
      this.$emit('total',messageData)
    },
    handleReset(){
      this.$set(this,'queryForm', {})
       this.$refs.selectDom.removeData()
      // if(!this.isEnterprise){
      //     this.$refs.selectDom.removeData()
      // }else{
      //   this.$refs.cascaderSelect.handleClear()
      // }
      this.getData();
    },
    onSearchProject(tenantName){
      this.getWareHouse(tenantName)
    },
    getWareHouse(tenantName=null){
      const data = {
          customerCodes: [this.$store.state.user.customerCode],
          needExcludeDefaultTenant: true,
          tenantName,
          isReadConfig:true
      }
      getWareHouse(data,{size:500}).then((res) => {
        if(res.records.length <= 0){
          this.ProjectList = []
          this.$message.warning('未选择仓库,无法查询数据')
          return
        }
        const arr = res.records.map((e) => {
            return {
                ...e,
                label: e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
        })
        this.ProjectList = arr
        if(this.goodsData.length <= 0){
          if(arr.length > 0 && !this.queryForm.shipperId){
            this.queryForm.warehouseCode = arr[0].tenantId
            this.queryForm.shipperId = arr[0].customerId
          }
          this.getData()
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.table-content {
  border-top: 1px solid #E7E9EC;
  padding-top: 24px;
  // padding: 12px 30px;
  // margin-top: 5px;
  // background-color: #fff;
  // border-radius: 6px;
  .operate_bar {
    margin-bottom: 24px;
    .btn_export {
      border: 1px solid #06B880;
      color: #06B880;
    }
  }
}
.search_content {
  margin-bottom: 12px;
}
.search-pane {
  padding: 24px;
  background-color: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.search-btn {
  margin-top: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.moreData {
  height: 30px;
  line-height: 30px;
  background-color: #fff;
  font-size: 12px;
  &:hover {
    cursor: pointer;
  }
}
.nextForm{
  margin-top: 15px;
  transition: all ease .2s;
}
.nextFormActive{
  height: auto;
}
.form-row {
  .formTitle{
    text-align: right;
    padding-right: 6px;
    width: 100%;
    display: inline-block;
    font-size: 0.8rem;
    line-height: 32px;
  }
}
.orderName {
  padding-left: 80px;
  .ant-input-group {
    width: 300px;
  }
}
.batch_form {
    /deep/.ant-form-item {
      width: 100%;
      .ant-form-item-label {
        width: 80px;
      }
      .ant-form-item-control-wrapper {
        width: calc(100% - 80px);
      }
    }
    .ant-col-6 {
      padding-right: 20px;
    }
    .form-btns {
      text-align: center;
      .form-btn {
        margin-left: 20px;
      }
    }
  }
  .batch_form {
    /deep/.ant-form-item-label label {
      color: #606266;
    }
    /deep/ .ant-form-item-control-wrapper input {
      color: #171717 !important;
    }

  }
  .search_btn {
    color: #06B880;
    border-color: #06B880;
  }
  .overlength {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
</style>